import { type Brand } from '@curology/ui-components-web/brand';

import { curologyUrls } from './curologyUrls';
import { getActiveAgencyUrls } from './getActiveAgencyUrls';

/**
 * Brand-aware URL set that honors the agencyskin rebrand flag.
 *
 * For Agency, `site` swaps to the agencyskin destination when `isRebrandLive`
 * is true (see getActiveAgencyUrls); every other group, and Curology as a
 * whole, is unaffected. Pass `useFlag('agency-rebrand')` on the client or
 * `getFlag('agency-rebrand')` on the server.
 */
export const getActiveUrls = (brand: Brand, isRebrandLive: boolean) =>
  brand === 'agency' ? getActiveAgencyUrls(isRebrandLive) : curologyUrls;
